import styled from '@emotion/styled';
import { Button } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const WideButton = styled(Button)`
  width: 100%;
  display: block;
`;
